import { useState, useEffect } from 'react';

export default function EditRouteModal({
  editingRoute, routes, setEditingRoute,
  editingRouteSearch, setEditingRouteSearch,
  handleSearchRouteDestination, handleUpdateRouteDestination,
  searchingRouteDestination, setError, setSuccess,
  routeSearchLLMResult, setRouteSearchLLMResult
}) {
  const [poName, setPoName] = useState(routes[editingRoute]?.post_office || '');
  const [poAddress, setPoAddress] = useState(routes[editingRoute]?.post_office_address?.address_line1 || '');
  const [poCity, setPoCity] = useState(routes[editingRoute]?.post_office_address?.city || '');
  const [poState, setPoState] = useState(routes[editingRoute]?.post_office_address?.state || '');
  const [poZip, setPoZip] = useState(routes[editingRoute]?.post_office_address?.zip || routes[editingRoute]?.zip || '');

  // When LLM result comes in, update local state
  useEffect(() => {
    if (routeSearchLLMResult) {
      setPoName(routeSearchLLMResult.name);
      setPoAddress(routeSearchLLMResult.address_line1);
      setPoCity(routeSearchLLMResult.city);
      setPoState(routeSearchLLMResult.state);
      setPoZip(routeSearchLLMResult.zip);
      setRouteSearchLLMResult(null); // Clear the result after consuming it
    }
  }, [routeSearchLLMResult, setRouteSearchLLMResult]);

  return (
    <div style={{ position: "fixed", top: 0, left: 0, right: 0, bottom: 0, background: "rgba(0,0,0,0.5)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1000, padding: "1rem" }}>
      <div className="card" style={{ maxWidth: "600px", width: "100%" }}>
        <h3 style={{ fontSize: "1.25rem", fontWeight: 600, marginBottom: "1rem" }}>
          Edit Destination - Route {routes[editingRoute].route}
        </h3>
        {routeSearchLLMResult === null && (poName || poAddress) && (
          <div style={{ background: "#fffbeb", border: "1px solid #fbbf24", borderRadius: "8px", padding: "0.75rem 1rem", marginBottom: "1rem", fontSize: "0.8rem", color: "#92400e", display: "flex", alignItems: "flex-start", gap: "0.5rem" }}>
            <span style={{ fontSize: "1rem" }}>⚠️</span>
            <span><strong>AI-generated address:</strong> Please verify the street address below is correct before saving — AI can occasionally hallucinate street names.</span>
          </div>
        )}
        <div style={{ background: "#f0f9ff", border: "2px solid #bfdbfe", padding: "1rem", borderRadius: "8px", marginBottom: "1.5rem" }}>
          <label className="form-label" style={{ marginBottom: "0.5rem" }}>🔍 Search Post Office by Name</label>
          <div style={{ display: "flex", gap: "0.5rem" }}>
            <input type="text" className="form-input" value={editingRouteSearch} onChange={(e) => setEditingRouteSearch(e.target.value)} placeholder="e.g., Milford Post Office, Nappanee, IN" style={{ flex: 1 }} />
            <button className="btn btn-primary" onClick={handleSearchRouteDestination} disabled={searchingRouteDestination} style={{ whiteSpace: "nowrap" }}>
              {searchingRouteDestination ? "Searching..." : "Find Address"}
            </button>
          </div>
          <p style={{ fontSize: "0.75rem", color: "#64748b", marginTop: "0.5rem" }}>AI will search for the official USPS address for this location</p>
        </div>
        <div className="form-group" style={{ marginBottom: "1rem" }}>
          <label className="form-label">Post Office Name</label>
          <input type="text" className="form-input" value={poName} onChange={(e) => setPoName(e.target.value)} />
        </div>
        <div className="form-group" style={{ marginBottom: "1rem" }}>
          <label className="form-label">Street Address</label>
          <input type="text" className="form-input" value={poAddress} onChange={(e) => setPoAddress(e.target.value)} />
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "1rem", marginBottom: "1rem" }}>
          <div className="form-group">
            <label className="form-label">City</label>
            <input type="text" className="form-input" value={poCity} onChange={(e) => setPoCity(e.target.value)} />
          </div>
          <div className="form-group">
            <label className="form-label">State</label>
            <input type="text" className="form-input" value={poState} onChange={(e) => setPoState(e.target.value)} />
          </div>
        </div>
        <div className="form-group" style={{ marginBottom: "1.5rem" }}>
          <label className="form-label">ZIP Code</label>
          <input type="text" className="form-input" value={poZip} onChange={(e) => setPoZip(e.target.value)} />
        </div>
        <div style={{ display: "flex", gap: "0.75rem", justifyContent: "flex-end" }}>
          <button className="btn btn-outline" onClick={() => { setEditingRoute(null); setEditingRouteSearch(""); setError(""); setSuccess(""); }}>Cancel</button>
          <button className="btn btn-primary" onClick={() => {
            handleUpdateRouteDestination(editingRoute, poName, { name: poName, address_line1: poAddress, city: poCity, state: poState, zip: poZip });
            setEditingRouteSearch("");
          }}>Save</button>
        </div>
      </div>
    </div>
  );
}